import React, { useState } from 'react';
import { Modal, Button,Collapse,Row,Col,Descriptions,Typography } from 'antd';
import Spreadsheet from 'react-spreadsheet';
import styled from 'styled-components';
import {useParentState} from 'utils';
import { v4 as uuidv4 } from 'uuid';
import keywords,{keyGroupArray,keyToLabel,getLabelKey} from './keywords';
import ExcelImportIcon from './icon';
import Language from './language';
const MyModal =styled(Modal)`
  .ant-modal-body {
  display: flex;
  flex-direction: column;
  // align-content: center;
  align-items: center;
}
`;
const lng="en";

const { Panel } = Collapse;




function jsonArrayToSpreadsheetData(columns,_jsonArray) {
  
  
  if (!_jsonArray || !Array.isArray(_jsonArray) || _jsonArray.length === 0) {
    return { data: [[]], columns: [] }; // Return an empty spreadsheet data object if the input is invalid
  }
  
  const jsonArray = _jsonArray.map(o=>({...o,errors:""}))// Remove errors
  // const columns = Object.keys(jsonArray[0]).filter(key=>key!="id");
  
  // const props = schema?.items?.properties||{}
  // const columns = Object.keys(props).map(key=>props[key]).filter(o=>o.key=!"id")
  
  
  const data=[];
  
  jsonArray.forEach((item) => {
    const row = columns.map(({key,filters,group}) => ({ value: filters?filters.find(o=>o.value==item[key])?.text:keyToLabel(group||key,item[key],"en") }));
    data.push(row);
  }); 
  
  return { data, columns };
}

function spreadsheetDataToJsonArray({lng,columns,data}) {  
 const getValue=({key,group,filters},row)=>{
    if(!filters)return getLabelKey(lng,key,row?.value,group||key);
    
    const label = getLabelKey(lng,key,row?.value,group||key,lng);
    
    
    return filters.find(o=>o.text==label)?.value;   
 };
 const response=data.map(item=>columns.reduce((acc,column,i)=>({...acc,[column.key]:getValue(column,item[i])
 
 
 }),{})); 
 
 return response;
}


const MySpreadsheetModal = ({schema,data:initialData,isVisible:_isVisible=true,setVisible:_setVisible,onFinish,columns:_columns}) => {
  
  const [isVisible, setVisible] = useParentState(_isVisible,_setVisible);
  const [spreadsheetData, setSpreadsheetData] = useState();
  // const [columns, setColumns] = useState();
  const columns = _columns.filter(({key})=>key!="id")
  React.useEffect(()=>{
    const {data} = jsonArrayToSpreadsheetData(columns,initialData);  
    
    setSpreadsheetData([...data, [columns.map(c=>({value:''}))]]);
    
    // setColumns(columns);
    },[initialData]);
  
  const handleOk = () => {
    setVisible(false);
    const newData=spreadsheetDataToJsonArray({lng:"en",columns,data:spreadsheetData}).filter(row=>Object.keys(row).some(key=>row[key])).map(o=>({...o,id:uuidv4()}));    
    
    onFinish && onFinish(newData);    
  };

  const handleCancel = () => {
    setVisible(false);
  }; 
  const handleChange = (newData) => {   
    
    setSpreadsheetData(newData);
  };

  const addNewRow = () => {
    const newRow = [columns.map(c=>({value:''}))];
    setSpreadsheetData([...spreadsheetData, newRow]);
  };
const items = [
  {
    key: '1',
    label: <Language id="columns"/>,
    children: <div> {columns.map(col => (
                <Descriptions column={1} key={col.key} bordered size="small" style={{ marginBottom: '15px' }}>        
        <Descriptions.Item labelStyle={{width:200}} label=<Language id="name"/>><Row gutter={16}>{col.title} </Row></Descriptions.Item>
        <Descriptions.Item labelStyle={{width:200}} label=<Language id="description"/>><Row gutter={16}>{col?.description} </Row></Descriptions.Item>
        {col.filters && (
          <Descriptions.Item label=<Language id="options"/>>
           
              {col.filters.map(({text}, index) => (
               <Row key={index} gutter={16}>
                <Col  span={24}> {/* Adjust 'span' value based on how many columns you want */}
                  {text}
                </Col>
                 </Row>
              ))}
           
          </Descriptions.Item>
        )}
      </Descriptions>
                ))}</div>,
  },
];
const title = <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography.Title style={{margin:0,marginRight:32}} level={2}><Language id="import"/></Typography.Title>
          <ExcelImportIcon />
          
        </div>
  return (
   
      <MyModal        
        title={title}
        visible={isVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        maskClosable={false}
        
        width={800}
      >
       <div style={{width: '100%',overflow: "auto"}}>   
          <p style={{ marginBottom: '10px', color: '#888' }}>
     <Language id="excelsheet"/>
    </p>
          <Collapse defaultActiveKey={[]} items={items}style={{ marginBottom: '10px' }} />            
         </div>
        <div style={{maxWidth: '100%',overflow: "auto"}}>                   
          <Spreadsheet data={spreadsheetData} columnLabels={columns.map(o=>o.title)} onChange={handleChange} />
         
         </div>
         
      </MyModal>    
  );
};

export default MySpreadsheetModal;

